export default __webpack_public_path__ + "static/media/Cybersecurity_Mentor.3e6b05dc.png";